export const removeSpaces = string => {
  return string.replaceAll(/\s/g, "")
}
